import {
  getList,
  getObject,
} from "@surya-digital/leo-ts-types";
import { ChatSurveyElement } from "./chatSurveyElement";
import { ProgressPercentage, ProgressPercentageDTO } from "./progressPercentage";
import { ChatSurveyNextAction } from "./chatSurveyNextAction";

export interface ChatSurveyStateDTO {
  elements: ChatSurveyElement.ChatSurveyElementDTO[];
  progressPercentage: ProgressPercentageDTO;
  nextAction: ChatSurveyNextAction.ChatSurveyNextActionDTO;
}

export class ChatSurveyState {
  readonly isChatSurveyStateChatSurveyState: boolean = true;

  readonly elements: ChatSurveyElement.ChatSurveyElement[];
  readonly progressPercentage: ProgressPercentage;
  readonly nextAction: ChatSurveyNextAction.ChatSurveyNextAction;


  constructor(
  elements: ChatSurveyElement.ChatSurveyElement[], 
  progressPercentage: ProgressPercentage, 
  nextAction: ChatSurveyNextAction.ChatSurveyNextAction
  ) {
    this.elements = elements;
    this.progressPercentage = progressPercentage;
    this.nextAction = nextAction;
  }

  static fromDTO(dto: ChatSurveyStateDTO): ChatSurveyState {
    const elements = getList<ChatSurveyElement.ChatSurveyElementDTO, ChatSurveyElement.ChatSurveyElement>(
      dto,
      "elements",
      ChatSurveyElement.fromDTO,
      InvalidChatSurveyStateElementsError
    );
    const progressPercentage = ProgressPercentage.fromDTO(getObject(dto, "progressPercentage", InvalidChatSurveyStateProgressPercentageError));
    const nextAction = ChatSurveyNextAction.fromDTO(getObject(dto, "nextAction", InvalidChatSurveyStateNextActionError));
    return new ChatSurveyState(
      elements,
      progressPercentage,
      nextAction
    );
  }

  toDTO(): ChatSurveyStateDTO {
    const dto: ChatSurveyStateDTO = {
        elements: this.elements.map((e: ChatSurveyElement.ChatSurveyElement) => { return e.toDTO(); }),
        progressPercentage: this.progressPercentage.toDTO(),
        nextAction: this.nextAction.toDTO()
    };
    return dto;
  }
  }

ChatSurveyState.prototype.toString = function toString(): string {
  return `ChatSurveyState(elements='${this.elements}',progressPercentage='${this.progressPercentage}',nextAction='${this.nextAction}')`;
};

export class InvalidChatSurveyStateError extends Error {
  constructor(message?: string) {
    super(message);
    Object.setPrototypeOf(this, new.target.prototype);
    this.name = "InvalidChatSurveyStateError";
  }
}
export class InvalidChatSurveyStateElementsError extends InvalidChatSurveyStateError {
  constructor(message?: string) {
    super(message);
    Object.setPrototypeOf(this, new.target.prototype);
    this.name = "InvalidChatSurveyStateElementsError";
  }
}

export class InvalidChatSurveyStateProgressPercentageError extends InvalidChatSurveyStateError {
  constructor(message?: string) {
    super(message);
    Object.setPrototypeOf(this, new.target.prototype);
    this.name = "InvalidChatSurveyStateProgressPercentageError";
  }
}

export class InvalidChatSurveyStateNextActionError extends InvalidChatSurveyStateError {
  constructor(message?: string) {
    super(message);
    Object.setPrototypeOf(this, new.target.prototype);
    this.name = "InvalidChatSurveyStateNextActionError";
  }
}
